import { render, staticRenderFns } from "./DateTypeVariable.vue?vue&type=template&id=4b868d18&scoped=true&"
import script from "./DateTypeVariable.vue?vue&type=script&lang=js&"
export * from "./DateTypeVariable.vue?vue&type=script&lang=js&"
import style0 from "./DateTypeVariable.vue?vue&type=style&index=0&id=4b868d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b868d18",
  null
  
)

export default component.exports